import { createContext, useContext } from 'react'
import type { BaseOffersProviderProps, IOffersContext} from './OffersProvider'
import { defaults, OffersProvider } from './OffersProvider'
import { useCalculateOffers, useGetOffers } from '../hooks/useOffer'
import type { OfferPackage } from 'BrokerTsLib/src/dtos'

export const offersTravelContext = createContext<IOffersContext<OfferPackage>>(defaults as any)

export function OffersTravelProvider(props: BaseOffersProviderProps) {
  return (
    <OffersProvider
      signalRCalcFinishedEventName='TravelCalcFinished'
      useGetOffers={useGetOffers}
      useCalculateOffers={useCalculateOffers}
      context={offersTravelContext as any}
    >
      {props.children}
    </OffersProvider >
  )
}

export const useOffersTravelContext = () => {
  const context = useContext(offersTravelContext)

  if (context === undefined || Object.keys(context).length == 0) {
    throw new Error('useOffersTravelContext must be used within a OffersTravelProvider!')
  }

  return context
}